import type { QuizModel } from '~/common/models/quiz.model.ts';

export default defineNuxtPlugin(async () => {
  const quiz = ref<QuizModel>(await import('@/common/quiz/quiz_v1'));

  async function getQuiz(quizVersion: string) {
    switch (quizVersion) {
      case '3':
        quiz.value = await import('@/common/quiz/quiz_v3');
        break;
      case '2':
        quiz.value = await import('@/common/quiz/quiz_v2');
        break;
      case '1':
      default:
        quiz.value = await import('@/common/quiz/quiz_v1');
        break;
    }
  }

  return {
    provide: {
      quiz,
      getQuiz,
    },
  };
});
